import { useMemo } from "react";

const hairTipsStyles: { [key: string]: any } = {
  "processing-image": {
    slideBoxStyle: {
      gap: { base: "0.625rem", md: "0.9375rem" },
      px: "67px",
      color: "#FFFFFF",
    },
    slideHeaderTextStyle: {
      fontSize: { base: "16px", md: "25.39px" },
    },
    slideDescriptionTextStyle: {
      fontSize: { base: "14px", md: "22.22px" },
      lineHeight: { base: "20px", md: "31.74px" },
      fontHeight: 300,
    },
  },
  // TODO define small-loader styles in mobile (base)
  "small-loader": {
    slideBoxStyle: {
      gap: { base: "10px", md: "15px" },
      px: "67px",
      color: "#000000",
    },
    slideHeaderTextStyle: {
      fontSize: { base: "16px", md: "24.52" },
    },
    slideDescriptionTextStyle: {
      fontSize: { base: "14px", md: "21.45px" },
      lineHeight: { base: "20px", md: "30.65px" },
      fontHeight: 300,
    },
  },
};

export const useHairTipsStyles = (place: string) => {
  return useMemo(() => {
    const style = hairTipsStyles[place];
    const slideBoxStyle = style.slideBoxStyle;
    const slideHeaderTextStyle = style.slideHeaderTextStyle;
    const slideDescriptionTextStyle = style.slideDescriptionTextStyle;

    return { slideBoxStyle, slideHeaderTextStyle, slideDescriptionTextStyle };
  }, [place]);
};
